
        import { createElement as _createElement } from 'react';
import { Fragment as _Fragment } from 'react';
import _map from 'lodash-es/map';
export default function garageRT () {
    return _createElement('div', { 'className': 'cm_garage' }, _createElement('a', {
        'className': 'cm_toggle-dropdown garage-button',
        'title': 'Garage: ' + this.size + ' item(s)',
        'tabIndex': '0',
        'role': 'button'
    }, _createElement('div', { 'className': 'garage-icon-container' }, _createElement('span', { 'className': 'custom-garage-icon' }, _createElement('svg', {
        'width': '18',
        'height': '17',
        'viewBox': '0 0 23 19',
        'fill': 'none',
        'xmlns': 'http://www.w3.org/2000/svg'
    }, _createElement('path', {
        'd': 'M0 6.29688C0 5.38281 0.527344 4.53906 1.40625 4.1875L10.8281 0.425781C11.0742 0.320312 11.3906 0.320312 11.6367 0.425781L21.0586 4.1875C21.9375 4.53906 22.5 5.38281 22.5 6.29688V17.4062C22.5 17.8984 22.1133 18.25 21.6562 18.25H19.9688C19.4766 18.25 19.125 17.8984 19.125 17.4062V8.125C19.125 7.52734 18.5977 7 18 7H4.5C3.86719 7 3.375 7.52734 3.375 8.125V17.4062C3.375 17.8984 2.98828 18.25 2.53125 18.25H0.84375C0.351562 18.25 0 17.8984 0 17.4062V6.29688ZM4.5 8.125H18V11.5H4.5V8.125ZM4.5 12.625H18V18.25H4.5V12.625ZM9 15.4375C9 15.7539 9.24609 16 9.5625 16H12.9375C13.2188 16 13.5 15.7539 13.5 15.4375C13.5 15.1562 13.2188 14.875 12.9375 14.875H9.5625C9.24609 14.875 9 15.1562 9 15.4375Z',
        'fill': '#363636'
    }))), this.size ? [_createElement('span', {
            'className': 'garage-size',
            'key': 'garage-size'
        }, this.size)] : null), _createElement('span', { 'className': 'garage-label' }, 'Garage')), [this.garageDropdown(function () {
            function repeatItems1(items, itemsIndex) {
                return [items(function () {
                        return _createElement('div', { 'className': 'garage-item' }, _createElement('span', {
                            'className': 'select-model',
                            'data-cm-role': 'select-vehicle'
                        }, this.vehicleString), _createElement('span', {
                            'className': 'remove-model',
                            'data-cm-role': 'remove-vehicle'
                        }, [_createElement('svg', {
                                'className': 'cm_icon cm_icon-times',
                                'height': '20px',
                                'role': 'img',
                                'viewBox': '0 0 22 22',
                                'key': '1910'
                            }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))]));
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'cm_garageDropdown' }, this.template === 'list' ? _createElement('div', {
                'className': 'cmTemplate_list',
                'key': '31'
            }, _createElement('div', { 'className': 'garage-content' }, _createElement('div', {
                'className': 'clear-garage',
                'data-cm-role': 'clear-garage'
            }, 'Clear garage'), _createElement.apply(this, [
                'div',
                { 'className': 'cmRepeater_items' },
                _map(this.items, repeatItems1.bind(this))
            ]), [this.addButton(function () {
                    return _createElement('div', { 'className': 'add-vehicle  cm_button cm_button__primary cm_addButton' }, [window.Convermax.config?.garageButtonText || 'Add a vehicle']);
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })])) : null, this.template === 'empty' ? _createElement('div', {
                'className': 'cmTemplate_empty',
                'key': '1435'
            }, _createElement('div', { 'className': 'garage-content' }, [this.addButton(function () {
                    return _createElement('div', { 'className': 'add-vehicle  cm_button cm_button__primary cm_addButton' }, [window.Convermax.config?.garageButtonText || 'Add a vehicle']);
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })], _createElement('ul', {}, _createElement('li', { 'className': 'vehicle-advantages' }, 'Store your vehicle in the garage'), _createElement('li', { 'className': 'vehicle-advantages' }, 'Get products for your vehicle'), _createElement('li', { 'className': 'vehicle-advantages' }, 'Easily find the parts you need')))) : null);
        }, {
            widgetName: 'undefined',
            items: undefined
        })]);
}
        export const componentNames = ["cm:addButton","cm:addButton","cm:garageDropdown"]